import { render } from "./tagsNew.vue?vue&type=template&id=2ba8c7ee"
import script from "./tagsNew.vue?vue&type=script&lang=js"
export * from "./tagsNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__